import React, { createContext, useContext } from 'react';
import useSnackbar from '../hooks/useSnackbar.js';

const UIContext = createContext();

export const useUIContext = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUIContext must be used within UIProvider');
  }
  return context;
};

export const UIProvider = ({ children }) => {
  // Snackbar hook
  const snackbarState = useSnackbar();

  const value = {
    // Snackbar
    snackbar: snackbarState.snackbar,
    showSnackbar: snackbarState.showSnackbar,
  };

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
};
